/** Client-side email check: local@domain with TLD ≥ 2 chars */
export function isValidEmail(value: string): boolean {
  const s = value.trim();
  if (!s || s.length > 254) return false;
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(s);
}

/** Counts digits only; accepts international formatting (spaces, +, dashes, parens). */
export function isValidPhone(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  return digits.length >= 10 && digits.length <= 15;
}

export const EMAIL_INVALID_MESSAGE = 'Please enter a valid email address.';
export const PHONE_INVALID_MESSAGE = 'Please enter a valid phone number (10–15 digits).';
